import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { queryClient } from './lib/react-query';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/common/ProtectedRoute';
import AdminRoute from './components/common/AdminRoute';
import AdminLayout from './components/admin/AdminLayout';
import PendingVerification from './components/common/PendingVerification';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminEmployees from './pages/admin/AdminEmployees';
import AdminEmployers from './pages/admin/AdminEmployers';
import AdminJobs from './pages/admin/AdminJobs';
import AdminPendingJobs from './pages/admin/AdminPendingJobs';
import AdminCompletedJobs from './pages/admin/AdminCompletedJobs';
import AdminJobRoles from './pages/admin/AdminJobRoles';
import AdminDocuments from './pages/admin/AdminDocuments';
import AdminPayments from './pages/admin/AdminPayments';
import ContractGate from './components/contracts/ContractGate';
import './App.css';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route 
              path="/" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/pending-verification" 
              element={
                <ProtectedRoute>
                  <PendingVerification />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/contract" 
              element={
                <ProtectedRoute>
                  <ContractGate />
                </ProtectedRoute>
              } 
            />
            {/* Admin Routes */}
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminLayout />
                </AdminRoute>
              }
            >
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="employees" element={<AdminEmployees />} />
              <Route path="employers" element={<AdminEmployers />} />
              <Route path="jobs" element={<AdminJobs />} />
              <Route path="jobs/pending" element={<AdminPendingJobs />} />
              <Route path="jobs/completed" element={<AdminCompletedJobs />} />
              <Route path="job-roles" element={<AdminJobRoles />} />
              <Route path="documents" element={<AdminDocuments />} />
              <Route path="payments" element={<AdminPayments />} />
            </Route>
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </BrowserRouter>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;


// Now this is a system for employee, but i want employer to do the same. and create job entity that employeer can post and employee can apply. if both matches then employee-employee will see that details on their calender like:


// 1. as a employee i will add available dates and my job role, distance to travel etc.
// 2. as a employer i will add dates when locum workers are required and for which role, how many hours i.e. 6/, and timings
// 3. when it matches  both will get notification and add that entry for some other potential color in calender
// 4. once both employee and employer approved it, consider it as one job and mark as another color in calender. 